module.exports = __webpack_public_path__ + "static/media/pokerTable.aec4446b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/pokerTable.png
 ** module id = 725
 ** module chunks = 0
 **/